<template>
  <div class='icon-container'>
    <!-- <EdssScore v-show="showScore" /> -->
    <div class="icon" ref="icon">

      <div class='nub' v-show="showNub"></div>
      <div :class="{active: activeIcon === 'run', fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-run.svg'>
        <div class='icon-copy'></div>
      </div>

      <div :class="{active: activeIcon === 'sport', fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-sport.svg'>
        <div class='icon-copy'></div>
      </div>

      <div :class="{active: activeIcon === 'walk-200',fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-walk-200.svg'>
        <div class='icon-copy'>increased limitation<br>in walking<br>ability</div>
        <div class="distance">200m</div>
      </div>

      <div :class="{active: activeIcon === 'walk-500',fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-walk-500.svg'>
        <div class='icon-copy'>increased limitation<br>in walking<br>ability</div>
        <div class="distance">500m</div>
      </div>

      <div :class="{active: activeIcon === 'walk',fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-walk-500.svg'>
        <div class='icon-copy'>increased limitation<br>in walking<br>ability</div>
      </div>

      <div :class="{active: activeIcon === 'cane',fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-cane.svg'>
        <div class='icon-copy'>require assistance<br>for walking</div>
      </div>

      <div :class="{active: activeIcon === 'wheelchair',fade: doFade}" class="icon-and-copy">
        <img src='@/assets/img/icon-wheelchair.svg'>
        <div class='icon-copy'>restricted to<br>a wheelchair</div>
      </div>

    </div>
  </div>

</template>

<script>
import yearBarIdxMapping from '../yearBarIdxMapping.js';
import gsap from 'gsap';
import lerpColor from '../lerpColor.js';
// import EdssScore from '@/components/EdssScore.vue';

export default {
  name: "EdssIcon",
  props: {
    showNub: Boolean,
    year: Number,
    showScore: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // EdssScore
  },
  mounted() {
    this.doFade = false;
    // this.activeIcon = this.yearIconStates[this.year];

    let idx = yearBarIdxMapping[this.year];
    this.$refs.icon.style.background = '' + this.getColor(1 - (idx / (21 - 4)));
    this.updateIcon(this.year, idx, 0);
  },
  methods: {
    getYPosByIdx(idx){
      return idx * this.barHeight - 20;
    },
    setIcon(year){
      this.activeIcon = this.yearIconStates[year];
    },
    getColor: function(v) {
      return lerpColor(v);
      //   return lerp('rgb(220, 80, 50)', 'rgb(100, 160, 225)', v);
    },
    updateIcon(year, idx, t = 0.5) {
      this.doFade = t === 0 ? false : true;
      this.setIcon(year);

      let yPos = this.getYPosByIdx(idx);
      let icon = this.$refs.icon;
      if (icon) {
        // subtract 4 since first 4 bars are always faded.
        icon.style.background = '' + this.getColor(1 - (idx / (21 - 4)));

        gsap.to(icon, t, {
          bottom: `${yPos}px`
        });
      }
    }

  },
  data() {
    return {
      barHeight: 20,
      activeIcon: 'walk',
      doFade: true,
      yearIconStates: [
        'run', // 0      
        'sport', // 1
        'walk-200', // 2
        'sport', // 3
        'cane', // 4
        'walk', // 5
        'walk', // 6
        'cane', // 7
        'walk-200', // 8
        'walk-200', // 9
        'walk-200', // 10
        'cane', // 11
        'walk-200', // 12
        'cane', // 13
        'cane', // 14
        'cane', // 15
        'cane', // 16
        'cane', // 17
        'wheelchair', // 18
        'wheelchair', // 19
        'wheelchair', // 20
        'wheelchair' // 21
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.nub {
  background: white;
  position: absolute;
  top: 50%;
  left: -10px;
  height: 2px;
  width: 6px;
}

.icon-container {
  position: relative;
  width: 100px;
}

.distance {
  position: absolute;
  bottom: -17px;
  left: 50%;
  font-size: 12px;
  font-weight: bold;
  font-family: Helvetica;
  transform: translate(-50%, 0);
}

.fade {
  transition: 1s ease all;
}

.icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;

  position: absolute;
  bottom: 0;

  .icon-and-copy {
    display: none;

    img {
      width: 100px;
      height: 100px;
      position: absolute;
      top: -50%;
      left: -50%;

    }

    .icon-copy {
      text-align: left;
      text-transform: uppercase;
      position: absolute;
      top: 50%;
      left: 55px;
      transform: translate(0px, -50%);
      width: 100px;
      font-size: rem(10px);
    }
  }

  .active {
    display: inline-block;
  }
}

// "ZOOMED IN" Mobility page styles
.icon-container.large-scale {
  width: auto;

  .nub {
    width: 70px;
    left: -75px;
    @media (max-width: 875px) {
      width: 30px;
      left: -40px;
    }
    @include breakpoint(xs) {
      display: none;
      width: 20px;
      left: -25px;
    }
    
  }

  .icon {
    left: 75px;
    @media (max-width: 875px) {
      left: 40px;
    }
    @include breakpoint(xs) {
      left: 22px;
      display: none;
    }
  }
}
</style>